import {ActionTree} from "vuex";
import {ProcessOperationImplementationState, ProcessOperationImplementation} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<ProcessOperationImplementationState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/process_operation_implementations', {params: params})
        .then((response: AxiosResponse) => {
          const processOperationImplementations: ProcessOperationImplementation[] = response.data;
          commit('setProcessOperationImplementations', processOperationImplementations);
          return processOperationImplementations;
        });
  },
  find({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].get(`/process_operation_implementations/${id}`)
        .then((response: AxiosResponse) => {
          const processOperationImplementation: ProcessOperationImplementation = response.data;
          commit('setProcessOperationImplementation', processOperationImplementation);
          return processOperationImplementation;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/process_operation_implementations', params)
        .then((response: AxiosResponse) => {
          const processOperationImplementation: ProcessOperationImplementation = response.data;
          commit('addProcessOperationImplementation', processOperationImplementation);
          return processOperationImplementation;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/process_operation_implementations/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const processOperationImplementation: ProcessOperationImplementation = response.data;
          commit('updateProcessOperationImplementation', processOperationImplementation);
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/process_operation_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteProcessOperationImplementation', id);
        });
  }
}

export default actions;
